import { render, staticRenderFns } from "./standing.vue?vue&type=template&id=0d51a796&scoped=true"
import script from "./standing.vue?vue&type=script&lang=js"
export * from "./standing.vue?vue&type=script&lang=js"
import style0 from "./standing.vue?vue&type=style&index=0&id=0d51a796&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51a796",
  null
  
)

export default component.exports